"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageGroupDtoMinTierEnum = void 0;
exports.instanceOfLanguageGroupDto = instanceOfLanguageGroupDto;
exports.LanguageGroupDtoFromJSON = LanguageGroupDtoFromJSON;
exports.LanguageGroupDtoFromJSONTyped = LanguageGroupDtoFromJSONTyped;
exports.LanguageGroupDtoToJSON = LanguageGroupDtoToJSON;
exports.LanguageGroupDtoToJSONTyped = LanguageGroupDtoToJSONTyped;
var LanguageItemDto_1 = require("./LanguageItemDto");
/**
 * @export
 */
exports.LanguageGroupDtoMinTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the LanguageGroupDto interface.
 */
function instanceOfLanguageGroupDto(value) {
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('minTier' in value) || value['minTier'] === undefined)
        return false;
    if (!('unlocked' in value) || value['unlocked'] === undefined)
        return false;
    if (!('items' in value) || value['items'] === undefined)
        return false;
    return true;
}
function LanguageGroupDtoFromJSON(json) {
    return LanguageGroupDtoFromJSONTyped(json, false);
}
function LanguageGroupDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'label': json['label'],
        'minTier': json['minTier'],
        'unlocked': json['unlocked'],
        'items': (json['items'].map(LanguageItemDto_1.LanguageItemDtoFromJSON)),
    };
}
function LanguageGroupDtoToJSON(json) {
    return LanguageGroupDtoToJSONTyped(json, false);
}
function LanguageGroupDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'label': value['label'],
        'minTier': value['minTier'],
        'unlocked': value['unlocked'],
        'items': (value['items'].map(LanguageItemDto_1.LanguageItemDtoToJSON)),
    };
}
